import { useCallback } from 'react';
import { TableFetchParams, tableQueryMaker } from '@core/table';
import { useService } from '@core/inversify-react';
import { message } from 'antd';

import { GetBranchInspectionsRepoType, IGetBranchInspectionsRepo } from '../../repos';

export const useBranchInspectionsTableContext = () => {
  const getBranchInspectionsRepo = useService<IGetBranchInspectionsRepo>(GetBranchInspectionsRepoType);

  const onFetch = useCallback(
    async (params: TableFetchParams) => {
      const result = await getBranchInspectionsRepo.execute(tableQueryMaker(params));

      if (result.status === 200) {
        return {
          data: result.response.data,
          total: result.response.total,
        };
      } else {
        message.error(result.response);
        throw new Error(result.response);
      }
    },
    [getBranchInspectionsRepo],
  );

  return { onFetch };
};
